/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  phone: {
    id: 'icons.phone',
    defaultMessage: 'Phone icon'
  },
  facebook: {
    id: 'icons.facebook',
    defaultMessage: 'Facebook icon'
  },
  search: {
    id: 'icons.search',
    defaultMessage: 'Watson Discovery search icon'
  },
  sms: {
    id: 'icons.sms',
    defaultMessage: 'SMS icon'
  },
  segment: {
    id: 'icons.segment',
    defaultMessage: 'Segment'
  },
  slack: {
    id: 'icons.slack',
    defaultMessage: 'Slack icon'
  },
  microsoftTeams: {
    id: 'icons.microsoftTeams',
    defaultMessage: 'Microsoft Teams icon'
  },
  webchat: {
    id: 'icons.webchat',
    defaultMessage: 'Web chat icon'
  },
  customSMS: {
    id: 'icons.customSMS',
    defaultMessage: 'Custom SMS'
  },
  whatsapp: {
    id: 'icons.whatsapp',
    defaultMessage: 'WhatsApp icon'
  },
  intercom: {
    id: 'icons.intercom',
    defaultMessage: 'Intercom icon'
  },
  custom: {
    id: 'icons.custom',
    defaultMessage: 'Custom icon'
  },
  genesys: {
    id: 'icons.genesys',
    defaultMessage: 'Genesys logo'
  },
  magnolia: {
    id: 'icons.magnolia',
    defaultMessage: 'Magnolia icon'
  },
  niceInContact: {
    id: 'icons.niceInContact',
    defaultMessage: 'Nice In Contact icon'
  },
  niceInContactLayerOne: {
    id: 'icons.niceInContactlayerOne',
    defaultMessage: 'Nice In Contact Minimal Layer One'
  },
  niceInContactLayerTwo: {
    id: 'icons.niceInContactLayerTwo',
    defaultMessage: 'Nice In Contact Minimal Layer Two'
  },
  niceInContactLayerThree: {
    id: 'icons.niceInContactLayerTwo',
    defaultMessage: 'Nice In Contact Minimal Layer Three'
  },
  niceInContactLayerFour: {
    id: 'icons.niceInContactLayerTwo',
    defaultMessage: 'Nice In Contact Minimal Layer Four'
  }
});
